module.exports = __webpack_public_path__ + "img/icon-pin.2728801e.svg";